'use client';

import StyledComponentsRegistry from '@/context/AntdRegistry';
import UseStorageProvider from '@/hooks/useStorage/Provider';
import Layouts from '@/layouts';

function Layout({ children }: { children: React.ReactNode }): JSX.Element {
  return (
    <StyledComponentsRegistry>
      <UseStorageProvider>
        <Layouts>{children}</Layouts>
      </UseStorageProvider>
    </StyledComponentsRegistry>
  );
}
export default Layout;
